module.exports = __webpack_public_path__ + "img/houston_repertoire.d5be8aa4.png";